import axios from 'axios';
import BaseApi from './base/BaseApi';

export default class FileApi extends BaseApi {
  static entityName = 'files';

  create(file, progressCallback = null, abortController = null) {
    const iri = this.getIri();

    const formData = new FormData();
    formData.append('file', file, file.name);

    return axios.post(iri, formData, {
      signal: abortController.signal,
      onUploadProgress: (progressEvent) => {
        if (progressCallback) {
          const progress = progressEvent.loaded / progressEvent.total;
          progressCallback(progress * 100);
        }
      },
    });
  }
}
